<template>
  <div class="graphics container">
    <div id="content">
      <canvas class="canvas" id="myChart"></canvas>
    </div>
    <div id="cmd"></div>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

export default {
  name: "PlanetChart",
  data() {
    return {
      img: "",
      myChart: null,
      graphicLabels: null,
      graphicData: null,
    };
  },
  props: ["labels", "content", "highestValue"],
  watch: {
    labels: function() {
      this.graphicLabels = this.$props.labels;
    },
    content: async function() {
      this.graphicData = this.$props.content;
      await this.grafica();
    },
  },
  methods: {
    grafica: function() {
      var ctx = document.getElementById("myChart").getContext("2d");
      if (this.myChart != null) {
        this.myChart.destroy();
      }
      const footer = (tooltipItems) => {
        var sum = 0;

        tooltipItems.forEach((tooltipItem) => {
          sum = `Hombres: ${this.graphicData.perc.h[tooltipItem.parsed.x]}%\nMujeres: ${this.graphicData.perc.m[tooltipItem.parsed.x]}%`;
        });
        return sum;
      };
      this.myChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.graphicLabels,
          datasets: [
            {
              label: "Mujeres",
              data: this.graphicData.m,
              backgroundColor: ["#2ecc71"],
              borderColor: ["#2ecc71"],
              barThickness: 40
            },
            {
              label: "Hombres",
              data: this.graphicData.h,
              backgroundColor: ["#770baa"],
              borderColor: ["#770baa"],
              barThickness: 40
            },
          ],
        },
        options: {
          scales: {
            x: {
              title: {
                display: true,
                text: "Relación Laboral",
                font: {
                  weight: "bold"
                }
              },
              grid: {
                display: false
              }
            },
            y: {
              max: this.highestValue,
              display: true,
              title: {
                display: true,
                text: "Personas",
                font: {
                  weight: "bold"
                }
              }
            },
          },
          plugins: {
            legend: {
              display: true,
              position: "bottom",
            },
            tooltip: {
              callbacks: {
                footer: footer,
              },
            },
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.canvas {
  font-size: 14px;
  color: #052333;
}
.graphics {
  padding-bottom: 2rem;
  padding: 1rem 5rem;
}
</style>
